module.exports = __webpack_public_path__ + "static/media/Ecommerce1.dc238fa0.png";